@import '~style-sheet-helpers/core.less';

.order-alerts-modal-body {
  min-height: 400px;
  padding: 16px;
}
